import React from 'react';
import PropTypes from 'prop-types';
import { Content, Flex, Pane, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import P from '@leverege/promise';
import I18N from '@leverege/i18n';
import { connect } from 'react-redux';
import { TwoFactorPane } from '@leverege/api-ui-login';
import { GlobalState } from '@leverege/ui-redux';
import { Users } from '@leverege/api-redux';
import ChangePasswordForm from "../../login/ChangePasswordForm.js";
import Blocker from "../../../views/blocker/Blocker.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const screenIcon = 'https://molten-ui-assets.storage.googleapis.com/security-title.png';
const {
  t
} = I18N.ns('molten.screens.account.SecurityScreen');
class SecurityScreen extends React.Component {
  static propTypes = {
    showHeader: PropTypes.bool
  };
  static defaultProps = {
    showHeader: true
  };
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
    this.state = {
      project2FASettings: null,
      changePasswordKey: Date.now()
    };
  }
  load2FASettings = async () => {
    const {
      profile
    } = this.props;
    const settings = await GlobalState.dispatch((dispatch, getState, {
      api
    }) => {
      return api.project(profile.projectId).twoFactorSettings().get();
    });
    await GlobalState.dispatch(Users.get(profile.id));
    this.setState({
      project2FASettings: settings
    }, () => {
      this.initialLoad.resolve();
    });
  };
  onSetChangePasswordKey = () => {
    this.setState({
      changePasswordKey: Date.now()
    });
  };
  renderForm = validator => {
    const {
      user
    } = this.props;
    const {
      project2FASettings,
      changePasswordKey
    } = this.state;
    return /*#__PURE__*/_jsx(Flex, {
      variant: "colL",
      style: {
        maxWidth: '704px'
      },
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colL",
        children: [/*#__PURE__*/_jsx(TwoFactorPane, {
          project2FASettings: project2FASettings,
          profile: user
        }), /*#__PURE__*/_jsxs(Pane, {
          layout: "flex:colL",
          variant: "contentSection",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "setting|colM",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "sectionTitle|title",
              children: Config.get('SecurityScreen', 'changePasswordTitle', t('changePasswordTitle'))
            }), /*#__PURE__*/_jsx(Text, {
              variant: "sectionBody|subtitle",
              children: Config.get('SecurityScreen', 'changePasswordSubtitle', t('changePasswordSubtitle'))
            })]
          }), /*#__PURE__*/_jsx(ChangePasswordForm, {
            onSubmit: this.onSetChangePasswordKey
          }, changePasswordKey)]
        })]
      })
    });
  };
  render() {
    const {
      showHeader
    } = this.props;
    return /*#__PURE__*/_jsxs(Content, {
      children: [showHeader ? /*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "screenTitle",
          title: Config.get('ProfileScreen', 'screenTitle', t('screenTitle')),
          icon: Config.get('ProfileScreen', 'screenIcon', screenIcon)
        })
      }) : null, /*#__PURE__*/_jsx(Content.Area, {
        variant: "securityScreenContent|screenContent",
        children: /*#__PURE__*/_jsx(Blocker, {
          hooks: [{
            execute: () => {
              this.load2FASettings();
              return this.initialLoad;
            }
          }],
          render: this.renderForm,
          matchContext: {},
          context: this.props
        })
      })]
    });
  }
}
export default connect(state => {
  const userId = state.auth?.profile?.id;
  return {
    profile: state.auth.profile,
    user: state.users.lookup[userId]
  };
})(SecurityScreen);